export enum StudentStatListTableColumn {
  NAME = 'name',
  EMAIL = 'email'
}
